/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShopUserResponse = {
    firstName?: string;
    lastName?: string;
    email?: string;
    userStatus?: ShopUserResponse.userStatus;
    role?: ShopUserResponse.role;
};
export namespace ShopUserResponse {
    export enum userStatus {
        PENDING = 'PENDING',
        ACTIVE = 'ACTIVE',
        SUSPENDED = 'SUSPENDED',
    }
    export enum role {
        OWNER = 'OWNER',
        MANAGER = 'MANAGER',
        STAFF = 'STAFF',
    }
}

